import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppSharedModule } from 'app/app-shared.module';

interface UtilityCard {
  titleKey: string;
  descriptionKey: string;
  iconClass: string;
  route: string;
}

@Component({
  standalone: true,
  selector: 'app-utilities',
  imports: [AppSharedModule],
  templateUrl: './utilities.component.html',
  styleUrl: './utilities.component.scss',
})
export class UtilitiesComponent {
  private readonly router = inject(Router);

  public readonly cards: UtilityCard[] = [
    {
      titleKey: 'utilities.card-pass-to-pass-calculator-title',
      descriptionKey: 'utilities.card-pass-to-pass-calculator-description',
      iconClass: 'agres-field',
      route: '/utilities/pass-to-pass-calculator',
    },
    {
      titleKey: 'utilities.card-pwm-calculator-title',
      descriptionKey: 'utilities.card-pwm-calculator-description',
      iconClass: 'agres-tool',
      route: '/utilities/pwm-spray-calculator',
    },
  ];

  openCard(card: UtilityCard): void {
    this.router.navigate([card.route]);
  }
}
